import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { SPACING } from '@backrs_ui/common-ui/src/designSystem/spacing/spacing';
export var SIDEBAR_EMULATION_MARGIN = SPACING['spacing-sm'];
export var SIDEBAR_COLLAPSED_WIDTH = 72;
export var SIDEBAR_EXPANDED_WIDTH = 296;
export var SIDEBAR_COLLAPSED_WIDTH_WITH_SCROLLBAR = 80;
export var SIDEBAR_MOBILE_HEIGHT = 57;
export var SIDEBAR_FOOTER_CONTENT_WIDTH = "calc(".concat(SIDEBAR_EXPANDED_WIDTH, "px - ").concat(SPACING['spacing-2xl'], " - ").concat(SPACING['spacing-xl'], ")");
export var SIDEBAR_STRINGS = appStrings.modules.backrsSidebar;
